import { PayloadAction } from '@reduxjs/toolkit';
import { updateQuoteData } from '@ui/features/quote-builder/state/utilities/update-quote-data';

import { ExtraReducerBuilder } from '../../types/shared';
import { WritableQuoteBuilderStateType } from '../../types/state';
import { updateSnapQuote } from '../endpoints/update-snap-quote';
import { transformSnapQuoteToStoreState } from '../utilities/transform-quote';

function updateSnapQuoteFulfilled(
  state: WritableQuoteBuilderStateType,
  action: PayloadAction<typeof updateSnapQuote.Types.ResultType>,
) {
  const { quote } = transformSnapQuoteToStoreState(action.payload);

  updateQuoteData(state, quote);
}

export function updateSnapQuoteReducer(builder: ExtraReducerBuilder) {
  builder.addMatcher(updateSnapQuote.matchFulfilled, updateSnapQuoteFulfilled);
}
